var React = require('react');

function Realistic (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"9","r":"6","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M12 24L14 16H18L20 24L16 28L12 24Z","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M26 30V20C26 17.7909 24.2091 16 22 16H10C7.79086 16 6 17.7909 6 20V30","stroke":"currentColor","strokeWidth":"2","key":2})]);
}

Realistic.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Realistic;

Realistic.default = Realistic;
